import { CSSProperties } from "react";

export const itemCSS: CSSProperties = {
  background:
    "repeating-linear-gradient(-45deg, rgba(255,0,0,0.04), rgba(255,0,0,0.04) 15px, rgba(255,0,0,0.13) 15px, rgba(255,0,0,0.13) 30px)",
  marginLeft: "-5px",
  paddingLeft: "10px",
};
export const afterCSS: CSSProperties = {
  paddingRight: "5px",
};
